import { render, staticRenderFns } from "./subjectBtn.vue?vue&type=template&id=78904962&scoped=true"
import script from "./subjectBtn.vue?vue&type=script&lang=js"
export * from "./subjectBtn.vue?vue&type=script&lang=js"
import style0 from "./subjectBtn.vue?vue&type=style&index=0&id=78904962&prod&lang=less&scoped=true"
import style1 from "./subjectBtn.vue?vue&type=style&index=1&id=78904962&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78904962",
  null
  
)

export default component.exports